import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { EventHubsLinkedService, Dataset, format, IModel, Metamodel } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.eventHubs.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.EventHubs_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.EventHubs_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: EventHubsLinkedService.MODEL // Linked service redefined
        }
    }
})
export class EventHubsDataset extends Dataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
